// API Configuration
// Supports two modes: firestore (production), local (JSON files)

const API_MODE = process.env.REACT_APP_API_MODE || 'firestore';

// Validate API_MODE - Two modes supported
const VALID_MODES = ['firestore', 'local'];
if (!VALID_MODES.includes(API_MODE)) {
  console.warn(`Invalid API_MODE: ${API_MODE}. Falling back to 'firestore' mode.`);
}

export const apiConfig = {
  mode: VALID_MODES.includes(API_MODE) ? API_MODE : 'firestore',
  isFirestore: API_MODE === 'firestore' || !VALID_MODES.includes(API_MODE),
  isLocal: API_MODE === 'local'
};

export default apiConfig;
